import React from "react";
import iconClose from "../../Assets/images/icon_close.svg";

const TransactionHistory = ({ details, onClose }) => {
  
  return (
    <div className="popup_container">
      <div className="ssb-overlay" style={{ zIndex: 2016 }}></div>
      <div
        className="ssb-popup ssb-popup--round ssb-popup--bottom"
        style={{ width: "100%", height: "100%", zIndex: 2017 }}
      >
        <div id="transaction-history" className="transaction-history-wrapper bg-black text-white min-h-screen">
          <div className="history">
            <div className="title fs-18">
              <span>{details && details.transactionType} Details</span>
              <img
                src={iconClose}
                alt="Close"
                className="icon_close"
                onClick={onClose}
              />
            </div>
            <div className="history_info">
            <div className="bg-black text-white flex justify-center items-center">
              <div className=" p-6 rounded-lg w-full max-w-md shadow-lg">
                
                {/* Quantity Section */}
                <div className="text-center mb-10">
                  <h2 className="text-xs">Quantity</h2>
                  <p className="text-green-500 text-2xl text-white font-bold">{details && parseFloat(details.amount).toFixed(2)} USDT</p>
                  {
                    details && (
                      <p
                        className={`text-sm ${
                          details.status === "approved"
                            ? "text-green-400"
                            : details.status === "pending"
                            ? "text-yellow-400"
                            : details.status === "rejected"
                            ? "text-red-400"
                            : "text-gray-400"
                        }`}
                      >
                        {details.status === "approved"
                          ? "✅"
                          : details.status === "pending"
                          ? "⏳"
                          : details.status === "rejected"
                          ? "❌"
                          : ""}{" "}
                        {details.status.charAt(0).toUpperCase() + details.status.slice(1)}
                      </p>
                    )
                  }


                </div>

                {/* Deposit Details */}
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-400">Deposit Account</span>
                    <span className="text-white font-medium">Funding Account</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-400">Coin Type</span>
                    <span className="text-white font-medium"><div className="flex items-center">
                        <img
                          src={`/assets/images/coins/${details?.coin_symbol.toLowerCase()}-logo.png`}
                          alt="Coin Logo"
                          className="coin_logo"
                          id="coin_logo"
                        />
                        <span className="ff_NunitoSemiBold" id="coin_symbol">
                          {details && details.coin_symbol}
                        </span>
                        <span className="ff_NunitoRegular" id="entry"></span>
                      </div></span>
                  </div>

                  <div className="flex justify-between ">
                    <span className="text-gray-400">Time</span>
                    <span className="text-white font-medium">{details && details.created_at}</span>
                  </div>

                  <div className="flex justify-between  ">
                    <span className="text-gray-400">Status</span>
                    <span className="text-white font-medium capitalize"> {details && details.status}</span>
                  </div>

                  <div className="flex justify-between pb-2">
                    <span className="text-gray-400">Deposit Address</span>
                    <div className="text-white font-medium break-all">
                    {details && details.wallet_to}
                    </div>
                  </div>

                  
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
